// app/javascript/controllers/datepicker_controller.js
import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import Japanese from "flatpickr/dist/l10n/ja.js"

export default class extends Controller {
  static values = {
    dateFormat: { type: String, default: "Y-m-d" },
    altFormat: { type: String, default: "Y年m月d日" },
    enableTime: { type: Boolean, default: false },
    minDate: { type: String },
    maxDate: { type: String }
  }

  connect() {
    // Merge Japanese locale with custom settings
    const options = {
      locale: Japanese.ja,
      dateFormat: this.dateFormatValue,
      altInput: true,
      altFormat: this.altFormatValue,
      allowInput: true,
      disableMobile: true, // Ensures consistent behavior on mobile
      onChange: this.handleDateChange.bind(this)
    }

    // Add optional min/max date if provided
    if (this.hasMinDateValue) {
      options.minDate = this.minDateValue
    }
    if (this.hasMaxDateValue) {
      options.maxDate = this.maxDateValue
    }

    // Initialize flatpickr
    this.picker = flatpickr(this.element, options)
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
    }
  }

  handleDateChange(selectedDates, dateStr, instance) {
    // Dispatch a custom event that other Stimulus controllers can listen to
    const event = new CustomEvent("date-change", {
      detail: { 
        date: selectedDates[0], 
        formattedDate: dateStr,
        japaneseDisplay: instance.input.value
      }
    })
    this.element.dispatchEvent(event)
  }

  // Method to manually set date from outside
  setDate(date) {
    if (this.picker) {
      this.picker.setDate(date)
    }
  }

  // Method to clear the date
  clearDate() {
    if (this.picker) {
      this.picker.clear()
    }
  }
}